import axios from "axios";
import apiClient from "./index";

const publicApi = axios.create({
	headers: { "Content-Type": "application/json", },
});

// 기본 테마 조회
export const findDefaultThema = () => {
	return publicApi.get(`/sys/thema/findDefaultThema.json`);
}

// 현재 메인 테마 조회
export const findMainThema = () => {
	return publicApi.get(`/sys/thema/findMainThema.json`);
}


// 테마 목록 조회
export const findThemas = () => {
	return apiClient.get(`/admin/thema/findThemas.json`);
}

// 메인 테마 설정
export const updateMainThema = (id) => {
	return apiClient.put(`/admin/thema/${id}/updateMainThema.json`);
}

// 테마 상세 조회
export const findThema = (data) => {
	return apiClient.get(`/admin/thema/findThema.json`, { params: data });
}

// 테마 신규 등록
export const saveThema = (formData) => {
	return apiClient.post(`/admin/thema/saveThema.file`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

// 테마 정보 수정
export const updateThema = (id, formData) => {
	return apiClient.put(`/admin/thema/${id}/updateThema.file`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
}

// 테마 사용 여부 변경
export const changeThemaUseYn = (id, data) => {
	return apiClient.put(`/admin/thema/${id}/changeThemaUseYn.json`, data);
}

// 파일 다운로드
export const fileDownloadProc = (name, id) => {
	return apiClient.get(`/admin/themaFile/${name}/${id}/fileDownload.json`, { responseType: 'blob' });
}

// 다중 파일 다운로드
export const filesDownloadProc = (name, files) => {
	return apiClient.post(`/admin/themaFile/${name}/filesDownload.json`, files, { responseType: 'blob' });
}